/**
 * @file home.js
 */
import {Url} from '@/utils/api.js';
import {get} from '@/utils/decorate/request';
import toast from '@/utils/decorate/toast';

export default {
    state: {
        maxTitleWidth: {
            board3: '60%',
            boardDefault: '55%'
        },
        homeData: {},
        errorImg: require('@/assets/images/error.png'),
        isLoading: false,
        activeTag: 0,
        activeSort: 0
    },
    mutations: {
        setHomeData(state, data) {
            state.homeData = data;
        },
        clearHomeData(state) {
            state.homeData = {};
        },
        changeData(state, data) {
            state.homeData.topicList = data.topicList;
            state.homeData.pageInfo = data.pageInfo;
            state.homeData.boardInfo = data.boardInfo;
        },
        loadMoreData(state, data) {
            state.homeData.topicList = state.homeData.topicList.concat(data.topicList);
            state.homeData.pageInfo = data.pageInfo;
        },
        changeLoadingState(state, val) {
            state.isLoading = val;
        },
        changeActiveTag(state, tag) {
            state.activeTag = tag;
        },
        changeActiveSort(state, sort) {
            state.activeSort = sort;
        }
    },
    actions: {
        getHomeInfo({commit}, {params, query}) {
            let requestQuery = Object.assign({}, query);
            if (params.moduleid) {
                requestQuery.boardId = params.moduleid;
            }
            let url = Url.topicListUrl;
            return get(url, {...requestQuery})
                .then(data => {
                    commit('setHomeData', data);
                })
                .catch(errmsg => toast.error(errmsg));
        },
        getMainList({commit, dispatch, rootState, state}, {params = {}, query, loadMore = false}) {
            let requestQuery = Object.assign({}, rootState.common.filterQuery, query);
            if (params.moduleid) {
                requestQuery.boardId = params.moduleid;
            }
            let url = Url.topicListUrl;
            if (loadMore && state.homeData.pageInfo) {
                requestQuery.pageNo = +state.homeData.pageInfo.pageNo + 1;
            }
            return get(url, {...requestQuery})
                .then(data => {
                    if (loadMore) {
                        commit('loadMoreData', data);
                    }
                    else {
                        commit('changeData', data);
                    }
                })
                .catch(errmsg => {
                    dispatch('clearFilterState');
                    toast.error(errmsg);
                });
        },
        // 点击发布防止页面刷新
        clickPost() {
            let url = Url.addTopicSourceUrl;
            return get(url)
                .catch(errmsg => {
                    toast.error(errmsg);
                    return Promise.reject(errmsg);
                });
        }
    }
};
